
import React from "react";
import { useKgCanvasNavigation } from "../../kg/canvas/KgCanvasNavigationContext";
import { KgInspectorLinkRow } from "../KgInspectorLinkRow";
import type { KgInspectorNavLinkRowProps } from "./KgInspectorNavLinkRow.types";

export const KgInspectorNavLinkRow: React.FC<KgInspectorNavLinkRowProps> = ({
  link,
}) => {
  const { focusNode } = useKgCanvasNavigation();

  return (
    <KgInspectorLinkRow
      label={link.label}
      onFocusClick={
        link.canvasNodeId ? () => focusNode(link.canvasNodeId!) : undefined
      }
      externalUrl={link.externalUrl}
    />
  );
};

export default KgInspectorNavLinkRow;
